export default class SingleWhiteBook {
  init() {
    this.downloadForm = document.querySelector(
      '.single-guides__contact-form-block'
    );
    this.floatingButtonsDownload = document.querySelector(
      '.floating-buttons__download-button'
    );

    if (this.downloadForm && this.floatingButtonsDownload) {
      const intersectionCallback = (entries) => {
        entries.forEach((entry) => {
          if (this.floatingButtonsDownload) {
            this.floatingButtonsDownload.setAttribute(
              'tabindex',
              !entry.isIntersecting ? '0' : '-1'
            );

            if (entry.isIntersecting) {
              this.floatingButtonsDownload.classList.add(
                'floating-buttons__download-button--hidden'
              );
              setTimeout(() => {
                this.floatingButtonsDownload.style.display = 'none';
              }, 150);
            } else {
              this.floatingButtonsDownload.style.display = 'flex';

              requestAnimationFrame(() => {
                this.floatingButtonsDownload.classList.remove(
                  'floating-buttons__download-button--hidden'
                );
              });
            }
          }
        });
      };

      const observer = new IntersectionObserver(intersectionCallback);

      observer.observe(this.downloadForm);
    }
  }
}
